import { createAction, props } from '@ngrx/store';

import { ReplaceVehicleAnalyticsModel, SubmitOnlineBindRequestModel } from '@amfam/policy/models';
import { UnderwritingQuestion } from '@amfam/policy/vehicle/data-access';

import {
  ReplaceVehicleQuickQuoteContext,
  ReplaceVehicleQuickQuoteOperation
} from './quick-quote-enum';

export const setVehicleId = createAction(
  '[Replace Vehicle Quick Quote Feature] Set Vehicle Id',
  props<{ vehicleId: string }>()
);

export const setUnderWritingQuestions = createAction(
  '[Replace Vehicle Quick Quote Feature] Set UnderWriting Questions',
  props<{ underwritingQuestions: UnderwritingQuestion[] }>()
);

export const setContext = createAction(
  '[Replace Vehicle Quick Quote Feature] Set Context',
  props<{ context: ReplaceVehicleQuickQuoteContext }>()
);

export const setOperation = createAction(
  '[Replace Vehicle Quick Quote Feature] Set Operation',
  props<{ operation: ReplaceVehicleQuickQuoteOperation }>()
);

export const sendAnalytics = createAction(
  '[Replace Vehicle Quick Quote Feature] Send Analytics',
  props<{ payload: ReplaceVehicleAnalyticsModel }>()
);

export const resetQuickQuoteFeature = createAction('[Replace Vehicle Quick Quote Feature] Reset');

export const setQuote = createAction(
  '[Replace Vehicle Quote Comparison Component] Set Quote',
  props<{ payload: SubmitOnlineBindRequestModel }>()
);
